export default class HttpClient {
  constructor(url) {
    this.url = url || ''
  }
  async GET(path) {
    try {
      var url = this.url + path;
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
      });
      if (!response.ok) {
        throw response;
      }
      return response.json();
    } catch (err) {
      switch (err.status) {
        case 401:
          window.location = `https://rely.vtex.com/auth/api/authenticator/login?state=${encodeURIComponent(window.location.href)}`;
          break;
        default:
          console.log(err);
          throw err;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/http.js